module.exports = __webpack_public_path__ + "img/puzzle_3.c9530b2a.png";